// Mock data for Simpolo clone

export const heroBanners = [
  {
    id: 1,
    title: 'Glyphstone Collection',
    subtitle: 'Inspired By Petroglyphs',
    image: 'https://images.unsplash.com/photo-1706629503586-2731f65587ae?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80',
    link: '#glyphstone',
  },
  {
    id: 2,
    title: 'Venitto Collection',
    subtitle: 'Unique Terrazzo Designs',
    image: 'https://images.unsplash.com/photo-1455593984172-9f753a2e1ebd?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80',
    link: '#venitto',
  },
  {
    id: 3,
    title: 'Alchimia Collection',
    subtitle: 'Blend of raw potential & artistry',
    image: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80',
    link: '#alchimia',
  },
  {
    id: 4,
    title: 'Sparko Collection',
    subtitle: 'Make Your Home Look Expensive',
    image: 'https://images.unsplash.com/photo-1625163865002-c3563a586b95?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80',
    link: '#sparko',
  },
  {
    id: 5,
    title: 'Marmorica Collection',
    subtitle: 'Exclusive Marble Inspired Collection',
    image: 'https://images.unsplash.com/photo-1600328604921-300918f36018?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80',
    link: '#marmorica',
  },
];

// Use stylized text labels in the marquee strip instead of images
export const collectionLogos = [
  'GLYPHSTONE',
  'VENITTO',
  'ALCHIMIA',
  'SPARKO',
  'MARMORICA',
  'BASALTINO',
];

export const aboutInfo = {
  years: '25',
  yearsLabel: 'Years',
  image: 'https://images.unsplash.com/photo-1552475157-a68a1826ddb3?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85',
  title: 'About Indian Ceramic: A Trusted Vitrified Tiles Manufacturer in Morbi',
  description:
    'At Indian Ceramic, we curate collections that bring together beauty, innovation, and strength. Headquartered in Morbi - the ceramic capital of India - we manufacture and export premium vitrified tiles and bathware globally. Our craftsmanship balances timeless classics with bold modern designs, helping every customer find the perfect fit for their space.',
};

export const exploreLocations = [
  { name: 'Living Room', image: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Bathroom', image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Bedroom', image: 'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Kitchen', image: 'https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Balcony', image: 'https://images.pexels.com/photos/276746/pexels-photo-276746.jpeg?auto=compress&cs=tinysrgb&w=1600' },
  { name: 'Outdoor', image: 'https://images.unsplash.com/photo-1625163865002-c3563a586b95?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
];

export const exploreEffects = [
  { name: 'Marble', image: 'https://images.unsplash.com/photo-1600328604921-300918f36018?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Stone', image: 'https://images.unsplash.com/photo-1706629503571-c165023a7792?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Wood', image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Terrazzo', image: 'https://images.unsplash.com/photo-1736584762474-1d615c73b936?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Concrete', image: 'https://images.unsplash.com/photo-1455593984172-9f753a2e1ebd?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Solid', image: 'https://images.unsplash.com/photo-1720540244592-b4124532b318?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
];

export const exploreColors = [
  { name: 'Beige', image: 'https://images.unsplash.com/photo-1649446327070-d58c5a5aa15a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'White', image: 'https://images.unsplash.com/photo-1563219125-1db796e20ff2?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Grey', image: 'https://images.unsplash.com/photo-1706629503586-2731f65587ae?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Brown', image: 'https://images.unsplash.com/photo-1622372738946-62e02505feb3?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Black', image: 'https://images.unsplash.com/photo-1706629503571-c165023a7792?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'Multi', image: 'https://images.unsplash.com/photo-1736584762474-1d615c73b936?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
];

export const latestCollections = [
  { name: 'GLYPHSTONE', image: 'https://images.unsplash.com/photo-1706629503586-2731f65587ae?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'BASALTINO', image: 'https://images.unsplash.com/photo-1563219125-1db796e20ff2?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'ALCHIMIA', image: 'https://images.unsplash.com/photo-1706629503571-c165023a7792?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'SPARKO', image: 'https://images.unsplash.com/photo-1649446327070-d58c5a5aa15a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
  { name: 'VENITTO', image: 'https://images.unsplash.com/photo-1736584762474-1d615c73b936?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80' },
];

export const bathwareInfo = {
  hero: 'https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?crop=entropy&cs=srgb&fm=jpg&w=2400&q=85',
  title: 'Premium Bathware & Sanitaryware Collection',
  description:
    'We produce stylish and high-quality bathware solutions tailored to fulfill all your bath space needs, offering the ultimate experience.',
  items: [
    { name: 'SPOT LIGHT', image: 'https://images.unsplash.com/photo-1629079447777-1e605162dc8d?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
    { name: 'BASIN', image: 'https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
    { name: 'EWCS & PAN', image: 'https://images.pexels.com/photos/36121733/pexels-photo-36121733.jpeg?auto=compress&cs=tinysrgb&w=1400' },
  ],
};

export const digitalShowroom = [
  {
    title: 'Digital',
    titleAccent: 'Showroom',
    image: 'https://images.unsplash.com/photo-1720540244592-b4124532b318?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85',
  },
  {
    title: 'Virtual',
    titleAccent: 'Space Creator',
    image: 'https://images.unsplash.com/photo-1455593984172-9f753a2e1ebd?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85',
  },
];

export const tvCommercials = [
  { id: 'BQ_eyFD9g1Q', thumb: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
  { id: '4tBi8eH-JFQ', thumb: 'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
  { id: 'xBV3IO9pMP4', thumb: 'https://images.unsplash.com/photo-1625163865002-c3563a586b95?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
];

export const journeyItems = [
  { name: 'Catalogues', image: 'https://images.unsplash.com/photo-1622372738946-62e02505feb3?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
  { name: 'About Us', image: 'https://images.unsplash.com/photo-1552475157-a68a1826ddb3?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
  { name: 'Locate a Dealer', image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
  { name: 'Visit a Showroom', image: 'https://images.unsplash.com/photo-1720540244592-b4124532b318?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80' },
];

export const blogs = [
  { title: '10 Exterior Wall Tiles Design Ideas for Modern Home Exteriors', image: 'https://images.unsplash.com/photo-1455593984172-9f753a2e1ebd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: 'Creative Tile Patterns for Every Room in Your House', image: 'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: 'Grip Tiles for Outdoor: Durable Non-Slip Outdoor Tile Flooring', image: 'https://images.pexels.com/photos/276746/pexels-photo-276746.jpeg?auto=compress&cs=tinysrgb&w=1200' },
  { title: '10+ Blue Bathroom Tile Ideas to Transform Your Space', image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: 'Top 7 Modern Basin Design Ideas for 2024', image: 'https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: '10 Wall Colour Combinations to Transform Your Living Room', image: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: 'Colour for Living Room as per Vastu: Harmonise Energy & Style', image: 'https://images.unsplash.com/photo-1625163865002-c3563a586b95?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: 'Top 10 Kitchen Sink Designs for Modern Homes in 2026', image: 'https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80' },
  { title: 'Easy Living Room Decor Ideas to Transform Your Home Fast', image: 'https://images.pexels.com/photos/31737858/pexels-photo-31737858.jpeg?auto=compress&cs=tinysrgb&w=1200' },
];

export const navMenu = [
  { label: 'Tiles', sub: ['By Size', 'By Room', 'By Finish', 'Collections'] },
  { label: 'Bathware', sub: ['Wash Basin', 'Water Closets', 'Faucets', 'Showers'] },
  { label: 'Digital Visualizer' },
  { label: 'Projects' },
  { label: 'Catalogues' },
  { label: 'About Us' },
  { label: 'Blog' },
  { label: 'Contact' },
];
